import { Link } from "react-router-dom";
import { ChevronRight, KeyRound, LogOut } from "lucide-react";
import { can } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, UserAvatar } from "@/components/common";
import { NAV } from "@/components/layout/nav";

const SOON = [];

const Row = ({ to, icon: Icon, label, testid, onClick, right }) => {
  const cls = "flex w-full items-center gap-3 px-4 py-3.5 text-left text-sm font-medium transition-colors hover:bg-secondary";
  const inner = <><Icon className="h-5 w-5 text-muted-foreground" /><span className="flex-1">{label}</span>{right || <ChevronRight className="h-4 w-4 text-muted-foreground" />}</>;
  return to ? <Link to={to} className={cls} data-testid={testid}>{inner}</Link> : <button onClick={onClick} className={cls} data-testid={testid}>{inner}</button>;
};

export default function MorePage() {
  const { user, logout } = useAuth();
  const items = NAV.filter((n) => !n.key.match(/^(dashboard|chat|leads|properties)$/) && (!n.m || can(user, n.m)));
  return (
    <>
      <PageHeader title="More" testid="more-title" />
      <div className="mb-6 flex items-center gap-3 rounded-2xl border bg-card p-4">
        <UserAvatar user={user} size="lg" />
        <div>
          <p className="font-semibold">{user.name}</p>
          <p className="num text-xs text-muted-foreground">{user.mobile}</p>
        </div>
      </div>
      <div className="divide-y overflow-hidden rounded-2xl border bg-card">
        {items.map((n) => <Row key={n.key} to={n.to} icon={n.icon} label={n.label} testid={`more-${n.key}-link`} />)}
        <Row to="/change-password" icon={KeyRound} label="Change password" testid="more-change-password-link" />
        <Row onClick={logout} icon={LogOut} label="Log out" testid="more-logout-button" right={<span />} />
      </div>
      {SOON.length > 0 && <p className="label-xs mb-2 mt-8 px-1">Coming next</p>}
      <div className="divide-y overflow-hidden rounded-2xl border bg-card opacity-70">
        {SOON.map((s) => (
          <div key={s.label} className="flex items-center gap-3 px-4 py-3.5 text-sm">
            <s.icon className="h-5 w-5 text-muted-foreground" /><span className="flex-1">{s.label}</span>
            <span className="rounded-md bg-secondary px-2 py-0.5 text-[11px] font-semibold">{s.phase}</span>
          </div>
        ))}
      </div>
    </>
  );
}
